import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { AddReportPageRoutingModule } from "./add-report-routing.module";
import { AddReportPage } from "./add-report.page";
import { TranslateModule } from "@ngx-translate/core";
import { ReportModule } from "../report/report.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { UploadAttachmentModule } from "../../_component/upload-attachment/upload-attachment.module";
import { SelectButtonsModule } from "../../_component/select-buttons/select-buttons.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { CardComponentModule } from "../../_component/_structural/card/card.module";
import { InputsModule } from 'src/app/_component/inputs/inputs.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddReportPageRoutingModule,
    TranslateModule,
    ReportModule,
    HeaderModule,
    UploadAttachmentModule,
    SelectButtonsModule,
    LoadingStiModule,
    SelectDropdownModule,
    SharedDirectivesModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    InputsModule,
  ],
  declarations: [AddReportPage],
})
export class AddReportPageModule {}
